module.exports = "https://coursera_assets.s3.amazonaws.com/images/0f98f0cc3bb2a7ad7cd8067d4588e909.svg";